<template>
  <UiContentwrapper class="mb-16 pb-1 mt-8 lg:mt-28">
    <UiFullcolumn>
      <div class="mt-2 mb-7" v-html="headline">
        
      </div>
      <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
        
        <ProductModel 
          v-for="(product, index) in products" 
          v-motion-slide-visible-once-bottom 
          :delay="(index + 1) * 200" 
          :key="product.id" 
          :model-value="product" 
        />
        
      </div>
    </UiFullcolumn>
  </UiContentwrapper>

</template>

<script setup>

import { useProductStore } from '@/stores/productStore';
const ProductModel = defineAsyncComponent(() => import('@/components/product/model.vue'));

const productStore = useProductStore();
const mounted = ref(false);

const products = ref([]);

// Definiera props
const props = defineProps({
  headline: {
    type: String,
    default: '<h2>Gravaa Wheelsets:</h2>'
  },
  collection: {
    type: String,
    default: 'wheels'
  }
});


onMounted(async () => {
  if (!mounted.value) {
    mounted.value = true;
    products.value = await productStore.fetchCollectionProductsByHandle(props.collection);
  }
});


</script>

